import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { IPermitTypeField } from '~/client/graph/types.generated'
import ExpandableText from '~/client/src/shared/components/ExpandableText/ExpandableText'
import PermitFieldIcon from '~/client/src/shared/components/PermitFieldIcon/PermitFieldIcon'
import { NO_VALUE } from '~/client/src/shared/utils/usefulStrings'

// localization: no text to translate

interface IProps<T> {
  value: T
  typeField: IPermitTypeField
  isTitleShown: boolean
  isPaddingAdded: boolean

  viewModeRenderer(value: T): JSX.Element

  isContentFullWidth?: boolean
}

function WorkflowFormFieldViewMode<T>({
  value,
  typeField,
  isTitleShown,
  isPaddingAdded,
  viewModeRenderer,
  isContentFullWidth,
}: IProps<T>) {
  const renderViewMode = (value: T): JSX.Element => {
    if (viewModeRenderer) {
      return viewModeRenderer(value)
    }
    return <div className="text large tw:break-words">{value || NO_VALUE}</div>
  }

  return (
    <>
      {isTitleShown && (
        <div className="row tw:gap-2.5 no-grow y-start pt12">
          <PermitFieldIcon fieldName={typeField.type} />
          <div className="col pr6 overflow-hidden">
            <ExpandableText
              text={typeField.caption}
              title={typeField.caption}
              className="text light large tw:block tw:min-w-0 tw:whitespace-normal tw:break-words"
            />
          </div>
        </div>
      )}
      <div
        className={classList({
          'col overflow-hidden': true,
          'ml40 pr6': !isContentFullWidth,
          pb12: isPaddingAdded,
        })}
      >
        <div>{renderViewMode(value)}</div>
      </div>
    </>
  )
}

export default observer(WorkflowFormFieldViewMode)
